export enum VideoType {
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo',
}
